import React from 'react';
import PropTypes from "prop-types";

const Background = ({className, ...props}) => {
    return (
        <div id="wrapper">
            <div className={className}>
                <div className={"main"}>
                    {props.children}
                </div>
            </div>
        </div>
    );
};

Background.defaultProps = {
    className: "w1"
};

Background.propTypes = {
    className: PropTypes.string
};

export default Background;